// extracted by mini-css-extract-plugin
export var infoRow = "_ml-2";
export var labelContainer = "_ml-0";
export var rightInfo = "_ml-1";